import dayjs, { Dayjs } from "dayjs";

export const formatDate = (date: string | Dayjs, format?: "default") => {
  switch (format) {
    case "default": {
      return dayjs(date).format("YYYY/MM/DD HH:mm");
    }
    default: {
      return dayjs(date).format("YYYY/MM/DD HH:mm");
    }
  }
};
